import { STORAGE_IS_WORKSPACE_BAR_EXPANDED } from './AppUi.constants';
export const WorkspaceBarUtils = {
    getExpandedState: () => {
        try {
            const localStorageState = localStorage.getItem(STORAGE_IS_WORKSPACE_BAR_EXPANDED);
            switch (localStorageState) {
                case null:
                    return true;
                case 'true':
                    return true;
                case 'false':
                    return false;
                default:
                    return true;
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console -- logging
            console.error(`Couldn't read ${STORAGE_IS_WORKSPACE_BAR_EXPANDED} from localStorage`);
            return true;
        }
    },
    setExpandedState: (state) => {
        try {
            localStorage.setItem(STORAGE_IS_WORKSPACE_BAR_EXPANDED, JSON.stringify(state));
        }
        catch (error) {
            // eslint-disable-next-line no-console -- logging
            console.error(`Couldn't write ${STORAGE_IS_WORKSPACE_BAR_EXPANDED} to localStorage`);
        }
    },
};
